import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loggedIn: null,
    //  apiUrl: "http://localhost:8888/responsequeAPi/",
    apiUrl: "https://myresponseque.com/2019_RQV/",
    messages: []
  },

  getters: {
    // Here we will create a getter
    getMessages: state => {
      return state.messages;
    },
    getMessagesCount: (state, getters) => {
      return getters.getMessages.length;
    }
  },

  mutations: {
    LOGIN(state, action) {
      state.loggedIn = action;
    },
    GETMESSAGES(state, items) {
      state.messages = items;
    },
    DELETEMESSAGE(state, key) {
      state.messages.splice(state.messages.indexOf(key), 1);
    }
  },

  actions: {
    // Here we will create actions before making mutations
    logIn(context) {
      axios
        .post(this.state.apiUrl + "/Read/messages.php", {
          token: localStorage.getItem("token")
        })
        .then(res => {
          // unshift to push at the beginning of the array
          // this.comments.unshift(res.data[0]);
          if (res.data.error) {
            context.commit("LOGIN", false);
            localStorage.clear();
          } else {
            context.commit("LOGIN", true);
            context.commit("GETMESSAGES", res.data.data);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    deleteMessage(context, key) {
      context.commit("DELETEMESSAGE", key);
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js